<template>
  <!--
    바코드 인쇄.
  -->
  <v-row justify="center" id="noprint" class="printNone">
    <v-dialog
      v-model="barCodePrintdialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary" class="printNone">
          <v-btn icon dark @click.prevent="closeQrCodeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>정품 QR 코드 인쇄</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="print()">선택 품목 인쇄하기</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list class="printNone">
          <v-list-item class="justify-center">
            <v-btn depressed x-large disabled>
              <p class="black--text mb-0">정품인증코드 인쇄시 참고하세요</p>
            </v-btn>
            <v-list-item-content>
              <v-list-item-title class="grey--text caption ml-2">
                정품인증코드는 A라는 상품 1개당 발급되는 유니크한
                코드번호입니다. 동일한 상품이더라도 정품인증코드가 다르게
                발급됩니다.
              </v-list-item-title>
              <v-list-item-subtitle class="grey--text caption ml-2">
                상품에 여러장을 부착하거나 인쇄물이 오염/훼손된 경우
                인쇄하시려는 수량을 입력하여 사용하실 수 있습니다.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="row justify-start mt-0 mb-3 ml-4">
          <v-btn
            small
            color="grey darken-4"
            class="white--text"
            @click="printPaperCountSetting()"
          >인쇄수량 일괄설정</v-btn>
        </div>

        <v-divider class="printNone"></v-divider>

        <v-list three-line subheader class="printNone">
          <v-data-table
            v-model="selectedModal"
            :headers="headersModal"
            :items="productInfos"
            :server-items-length="productInfosCount"
            :options.sync="options"
            :loading="tableLoading"
            calculate-widths
            show-select
            :items-per-page="payload.limit"
            :footer-props="{
              'items-per-page-options': [50, 100, 300, 500],
              'items-per-page-text': '목록 노출 수 선택:',
            }"
            class="printNone"
            item-key="serial_number"
          >
            <template v-slot:item.created="{ item }" width="80px">
              <p
                class="mb-0 mt-3 text-center"
                v-html="$options.filters.defaultDate(item.created_at)"
              ></p>
            </template>

            <template v-slot:item.authCode="{ item }" width="80px">
              <p class="mb-0 mt-3">{{ item.serial_number }}</p>
            </template>

            <template v-slot:item.image="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters class="printNone">
                <v-col>
                  <v-img v-if="item.list_image" :src="item.list_image" width="60px" height="60px"></v-img>
                  <v-img v-else :src="adminDefaultImg" width="60px" height="60px"></v-img>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.productInfo="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters class="printNone">
                <v-col :cols="12" class="pl-0 pr-0 ml-0 mr-0" style="max-width:1000px">
                  <p class="mb-0 mt-3 mr-0 text-left text-truncate">상품명 : {{ item.product_name }}</p>
                  <p class="mb-3 mr-0 text-left text-truncate">품목명 : {{ item.variant_name }}</p>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.warrantyPeriodDays="{ item }" class="pl-0 pr-0">
              <p
                v-html="
                  $options.filters.warrantyPeriod({
                    cert_status: item.cert_status,
                    cert_duration_type: item.cert_duration_type,
                    cert_duration: item.cert_duration,
                    cert_validated_at: item.cert_validated_at,
                    cert_expired_at: item.cert_expired_at,
                  })
                "
              ></p>
            </template>

            <template v-slot:item.authState="{ item }" class="pl-0 pr-0">
              <p class="mb-0">{{ item.cert_status | certStatus }}</p>
            </template>

            <template v-slot:item.printCount="{ item }" class="pl-0 pr-0" :style="selectSize">
              <p class="mb-0">
                <v-text-field
                  v-model="item.print_count"
                  solo
                  height="50px"
                  class="d-inline-block durationCountText"
                  :value="item.print_count"
                  cols="12"
                  sm="6"
                  md="4"
                  :style="selectSize"
                  v-on:keyup="numberCheck(item)"
                ></v-text-field>
              </p>
            </template>
            <template slot="no-data">
              <div class="noDataProductInfos">내역이 없습니다.</div>
            </template>
          </v-data-table>
        </v-list>

        <A4Type1 ref="printType" v-if="printType == 'A4Type1'"></A4Type1>
        <A4Type2 ref="printType" v-else-if="printType == 'A4Type2'"></A4Type2>
        <RolLabelType1 ref="printType" v-else-if="printType == 'RolLabelType1'"></RolLabelType1>
        <RolLabelType2 ref="printType" v-else-if="printType == 'RolLabelType2'"></RolLabelType2>
      </v-card>
    </v-dialog>

    <!--
      Modal
    -->
    <v-row justify="center">
      <v-dialog v-model="printPaperCountSettingModal" max-width="370px">
        <v-card>
          <v-card-title>인쇄수량 일괄설정</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 200px;" class="pb-7">
            <p class="font-weight-bold mt-7 body-1 black--text mb-2">인쇄수량을 입력해주세요.</p>
            <p class="caption mb-0">한 품목에 여러개의 정품 QR 코드 인쇄물을 부착할 경우</p>
            <p class="caption mb-0">편리하게 사용하세요.</p>
            <p class="caption mb-0">선택된 품목의 인쇄수량에 일괄 입력이 가능합니다.</p>
            <v-col class="pl-0 pb-0">
              <v-text-field
                v-model="printPaperCount"
                solo
                height="50px"
                class="d-inline-block durationCountText mr-2 mt-3"
                :style="{width : '80px'}"
                v-on:keyup="printPaperCountNumber()"
              ></v-text-field>
              <font class="body-2 font-weight-bold">개</font>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="printPaperCountSettingModal = false">닫기</v-btn>
            <v-btn color="blue darken-1" text @click="printPaperCountSave();">저장</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-row>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
.durationCountText >>> input {
  text-align: right;
}
</style>
<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
import A4Type1 from "@/components/authservice/authcode/printType/A4Type1.vue";
import A4Type2 from "@/components/authservice/authcode/printType/A4Type2.vue";
import RolLabelType1 from "@/components/authservice/authcode/printType/RolLabelType1.vue";
import RolLabelType2 from "@/components/authservice/authcode/printType/RolLabelType2.vue";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      printType: "RolLabelType2",
      barCodePrintdialog: false,
      selectedModal: [],
      headersModal: [
        {
          text: "생성일시",
          align: "center",
          sortable: false,
          value: "created"
        },
        {
          text: "정품인증코드",
          align: "center",
          value: "authCode",
          sortable: false
        },
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 60
        },
        {
          text: "품목 정보",
          align: "center",
          value: "productInfo",
          sortable: false
        },
        {
          text: "보증기간",
          align: "center",
          value: "warrantyPeriodDays",
          sortable: false
        },
        {
          text: "인증상태",
          align: "center",
          value: "authState",
          sortable: false
        },
        {
          text: "인쇄수량",
          align: "center",
          value: "printCount",
          sortable: false
        }
      ],
      productInfosCount: 0,
      productInfos: [],
      selectSize: {
        height: "50px",
        width: "110px"
      },
      options: {},
      payload: {
        limit: 20,
        offset: 0
      },
      tableLoading: false,
      setDefaultPrintCount: 1,
      printPaperCountSettingModal: false,
      printPaperCount: 1,
      adminDefaultImg: require("../../../../assets/authservice/images/admin_default.png")
    };
  },

  components: {
    A4Type1,
    A4Type2,
    RolLabelType1,
    RolLabelType2
  },
  mixins: [CommonMixin],
  filters: Filters,
  watch: {
    options: {
      handler() {
        this.searchPrintProducts();
      },
      deep: true
    }
  },
  methods: {
    printPaperCountNumber: function() {
      this.printPaperCount = this.printPaperCount.replace(/[^0-9]/g, "");
    },
    numberCheck: async function(v) {
      this.selectedModal.map(item => {
        if (item.serial_number == v.serial_number) {
          let onlyNumber = v.print_count.replace(/[^0-9]/g, "");
          item.print_count = onlyNumber;
        }
      });
    },
    /**
     * 검색조건 셋팅
     */
    barCodePrintClick: function(payload) {
      payload["offset"] = 0;
      payload["limit"] = 20;
      this.payload = payload;
      this.barCodePrintdialog = true;
      this.searchPrintProducts();
    },
    /**
     * 페이징 및 상품 리스트
     */
    searchPrintProducts: async function() {
      let { page, itemsPerPage } = this.options;
      this.payload.offset = (page - 1) * itemsPerPage;
      this.payload.limit = itemsPerPage;
      this.tableLoading = true;
      let data = await M.api(M.entry("/cert/serials/search"), this.payload);
      if (Object.prototype.hasOwnProperty.call(data, "serials")) {
        this.productInfosCount = data.count;
        data.serials.forEach(list => {
          list["print_count"] = this.setDefaultPrintCount;
        });
        this.productInfos = data.serials;
        this.selectAll();
        this.tableLoading = false;
      } else {
        this.tableLoading = false;
      }
    },
    /**
     * 모달 닫기 데이터 초기화
     */
    closeQrCodeModal: function() {
      this.options.page = 1;
      this.selectedModal = [];
      this.barCodePrintdialog = false;
    },
    print: async function() {
      await this.setQrPrintList();
    },
    setQrPrintList: async function() {
      let selectedModalDistinguish = Array();
      for (let i = 0; i < this.selectedModal.length; i++) {
        let selectModalInfo = {
          serial_number: this.selectedModal[i].serial_number,
          print_count: this.selectedModal[i].print_count,
          product_name: this.selectedModal[i].product_name,
          variant_name: this.selectedModal[i].variant_name
        };

        if (!selectedModalDistinguish[this.selectedModal[i].product_code]) {
          selectedModalDistinguish[
            this.selectedModal[i].product_code
          ] = Array();
        }

        if (
          !selectedModalDistinguish[this.selectedModal[i].product_code][
            this.selectedModal[i].variant_code
          ]
        ) {
          selectedModalDistinguish[this.selectedModal[i].product_code][
            this.selectedModal[i].variant_code
          ] = Array();
        }

        selectedModalDistinguish[this.selectedModal[i].product_code][
          this.selectedModal[i].variant_code
        ].push(Array(selectModalInfo));
      }
      this.eventHub.$emit("setQrPrintList", selectedModalDistinguish);
    },
    printPaperCountSetting: async function() {
      this.printPaperCountSettingModal = true;
    },
    /**
     * 인쇄 수량 일괄 설정
     */
    printPaperCountSave: function() {
      let selectCounts = this.selectedModal.length;
      if (selectCounts > 0) {
        for (var i = 0; i < selectCounts; i++) {
          this.selectedModal[i].print_count = this.printPaperCount;
        }
        this.printPaperCountSettingModal = false;
      } else {
        this.alertShow("선택된 상품이 없습니다.");
      }
    },
    /**
     * 디폴트 : 전체 선택
     */
    selectAll: function() {
      this.selectedModal = [];
      for (var i = 0; i < this.productInfos.length; i++) {
        this.selectedModal.push(this.productInfos[i]);
      }
    }
  },
  mounted: async function() {
    try {
      let data = await M.api(M.entry("/get/print"), {});

      if (data.print_paper == "a4") {
        if (data.print_template == "type1") {
          this.printType = "A4Type1";
        } else {
          this.printType = "A4Type2";
        }
      } else {
        if (data.print_template == "type1") {
          this.printType = "RolLabelType1";
        } else {
          this.printType = "RolLabelType2";
        }
      }
    } catch (e) {
      //console.log(e);
    }
  },
  beforeDestroy: async function() {
    this.eventHub.$off();
  }
};
</script>
